<div class="camera-box">
  <div class="d-flex flex-wrap gap-3 align-items-center justify-content-between">
    <div>
      <div class="fw-semibold">Face de referencia</div>
      <div class="text-secondary small">Status: {{ statusFaceReferencia }} | Referencias: {{ facesAtivas.length }}/{{ limiteFacesReferencia }}</div>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn btn-outline-primary"
        [disabled]="!funcionario.id || statusFaceReferencia !== 'capturada'"
        (click)="validarFace.emit()">
        Validar face
      </button>
      <button type="button" class="btn btn-outline-success" [disabled]="limiteFacesAtingido" (click)="capturarFace.emit()">Capturar face</button>
    </div>
  </div>

  <app-camera-facial
    *ngIf="cameraAtiva && (cameraModo === 'cadastro' || cameraModo === 'validacao')"
    class="d-block mt-3"
    [modo]="cameraModo"
    [rostoDetectado]="rostoDetectado"
    [provaVidaOk]="provaVidaOk"
    [capturando]="capturando"
    [mensagem]="mensagemCamera"
    [caixaFace]="caixaFace"
    [exibirCancelar]="true"
    (confirmar)="confirmarFace.emit()"
    (cancelar)="cancelarFace.emit()">
  </app-camera-facial>

  <div *ngIf="facesAtivas.length && !cameraAtiva" class="faces-referencia mt-3">
    <div *ngFor="let face of facesAtivas; let indice = index" class="face-card">
      <img *ngIf="face.imagemBase64" class="face-preview" [src]="face.imagemBase64" alt="Face de referencia">
      <div *ngIf="!face.imagemBase64" class="face-placeholder">Sem imagem</div>
      <div class="face-card-footer mt-2">
        <div>
          <div class="small text-secondary">Referencia {{ indice + 1 }}</div>
          <span *ngIf="face.principal" class="badge text-bg-success">Principal</span>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-danger face-remover-btn"
          title="Remover face"
          aria-label="Remover face"
          (click)="solicitarRemocaoFace(face.id)">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="faceRemocaoPendente && !cameraAtiva" class="modal-backdrop fade show"></div>
  <div
    *ngIf="faceRemocaoPendente && !cameraAtiva"
    class="modal fade show modal-confirmacao-face"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modalConfirmacaoFaceTitulo">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header modal-confirmacao-face-header">
          <h5 class="modal-title" id="modalConfirmacaoFaceTitulo">Aten&ccedil;&atilde;o!</h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Fechar" (click)="cancelarRemocaoFace()"></button>
        </div>
        <div class="modal-body modal-confirmacao-face-body">
          Deseja excluir?
        </div>
        <div class="modal-footer modal-confirmacao-face-footer">
          <button type="button" class="btn btn-secondary modal-confirmacao-face-btn" (click)="cancelarRemocaoFace()">N&atilde;o</button>
          <button type="button" class="btn btn-danger modal-confirmacao-face-btn" (click)="confirmarRemocaoFace()">
            Sim
          </button>
        </div>
      </div>
    </div>
  </div>

  <img *ngIf="exibirImagemLegada" class="face-preview mt-3" [src]="funcionario.imagemFacialBase64" alt="Face capturada">
</div>
